import { Website } from '../enums/shop-enum';

export const isEDDEnabledSite = site => [Website.FR, Website.BE].includes(site);
